var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInformationTechnology = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EDEFF2",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#475E7B",
    fillRule: "evenodd",
    d: "M7.719 7.422a.8.8 0 0 0-.475.443c-.078.168-.081.42-.082 5.561l-.001 5.386-1.02 1.225-1.02 1.224.025.221c.047.395.315.744.713.927l.22.102H26.24l.22-.102c.399-.183.667-.532.714-.927l.026-.22-1.02-1.225-1.02-1.225-.002-5.386c0-5.129-.004-5.393-.081-5.563a.86.86 0 0 0-.525-.46c-.11-.03-2.87-.045-8.414-.044-6.872.002-8.278.012-8.419.063m11.46 13.467.287.342-1.653.012c-.909.006-2.397.006-3.306 0l-1.653-.012.288-.342.287-.341h5.461zm-1.295.851c.103.055.11.188.015.282-.06.06-.28.07-1.739.07s-1.679-.01-1.74-.07c-.091-.091-.087-.224.009-.28.106-.062 3.34-.064 3.455-.002",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEFF2",
    d: "M8.32 8.64a.32.32 0 0 1 .32-.32h15.04a.32.32 0 0 1 .32.32v9.28a.32.32 0 0 1-.32.32H8.64a.32.32 0 0 1-.32-.32z"
  })));
};
export default SvgInformationTechnology;